declare global {
  interface Window {
    PHN_ERROR_QUEUE?: Error[];
  }
}

export function initErrorQueue(): void {
  if (!window.PHN_ERROR_QUEUE) {
    window.PHN_ERROR_QUEUE = [];
  }
}

export function enqueueError(error: Error, id?: string): void {
  // eslint-disable-next-line no-console
  console.error(error);

  if (id && error instanceof Error) {
    error.message = `${id}: ${error?.message}`;
  }
  window.PHN_ERROR_QUEUE?.push(error);
}

export function getErrorQueue(): Error[] | undefined {
  return window.PHN_ERROR_QUEUE;
}

export function clearErrorQueue(): void {
  window.PHN_ERROR_QUEUE = [];
}

export function eventifyErrorQueue<T>(callback: (e: Error[]) => T): void {
  if (!window.PHN_ERROR_QUEUE) {
    return;
  }
  const queue = window.PHN_ERROR_QUEUE;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (queue.push as any) = (e: Error) => {
    Array.prototype.push.call(queue, e);
    callback(queue);
  };
}
